import React, {useEffect, useState} from 'react';
import {useRecoilState} from 'recoil';
import keyboardState from '../../state/ui/keyboardState';
import windowOffsetTopState from '../../state/ui/windowOffsetTopState';

const useKeyboard = () => {
  const [keyboard, setKeyboard] = useRecoilState(keyboardState);
  const [offsetTop, setOffsetTop] = useRecoilState(windowOffsetTopState);

  const [focused, setFocused] = useState(false);
  const onFocus = () => setFocused(true);
  const onBlur = () => setFocused(false);

  useEffect(() => {
    setKeyboard(focused);
  }, [focused]);

  useEffect(() => {
    if (keyboard) {
      setTimeout(() => {
        setOffsetTop(window.pageYOffset);
      }, 1000);
    }
  }, [keyboard]);

  return {keyboard, offsetTop, onFocus, onBlur};
};

export default useKeyboard;
